import { migration as initial } from "./001_initial";
import { migration as migrateToConnectors } from "./002_migrate_to_connectors";
import { migration as addDefaultAiMode } from "./003_add_default_ai_mode";

export const migrations = [initial, migrateToConnectors, addDefaultAiMode];
